var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnclaimed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#unclaimed_svg__clip0_7355_6158)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#unclaimed_svg__filter0_d_7355_6158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 3L5 5.912v12.765l.654.433C7.52 20.318 9.743 20.97 12 21c2.257-.03 4.481-.682 6.346-1.89l.654-.403V5.912L12 3z",
    fill: "#222238"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 6L5 18.5v.177l.654.433C7.52 20.318 9.743 20.97 12 21c2.257-.03 4.481-.682 6.346-1.89l.654-.403V6z",
    fill: "#2B2B47"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 18.5L5 6v12.677l.654.433C7.52 20.318 9.743 20.97 12 21c2.257-.03 4.481-.682 6.346-1.89l.654-.403V18.5z",
    fill: "#37375C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "unclaimed_svg__clip0_7355_6158"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "unclaimed_svg__filter0_d_7355_6158",
    x: 1,
    y: 1,
    width: 22,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7355_6158"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_7355_6158",
    result: "shape"
  })))));
}
export default __webpack_public_path__ + "static/_/shared/assets/svg/unclaimed.svg";
export { SvgUnclaimed as ReactComponent };